import React from 'react';
import { Helmet } from 'react-helmet';
import { Content, ImageBlock } from '~/containers/styles';
import Error404 from '../../../img/404NotFound.png';

export default () => (
  <Content>
    <Helmet>
      <title>ไม่พบข้อมูล</title>
    </Helmet>
    <div className="row">
      <div className="col-xs-12 text-center">
        <ImageBlock src={Error404} alt="Whooo" />
      </div>
    </div>
  </Content>
);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Error404/index.js